import { ALERT } from "../constants";
import { instance } from "../../axios";

// A shop's usage alerts (points outside opening hours, two locals within 2 h)
let latestRequest = 0;

const getAlertsAction = (limit, offset, type = null, companyId = null) => {
  return (dispatch) => {
    const request = ++latestRequest;
    dispatch({ type: ALERT.GET_ALERTS });
    const params = new URLSearchParams({ limit, offset });
    if (type) params.append("type", type);
    if (companyId) params.append("company_id", companyId);
    instance
      .get(`/alert?${params.toString()}`)
      .then((results) => {
        // A slower earlier request (another filter or page) must not win
        if (request !== latestRequest) return;
        dispatch({ type: ALERT.GET_ALERTS_SUCCESS, payload: results.data });
      })
      .catch((error) => {
        if (request !== latestRequest) return;
        dispatch({ type: ALERT.GET_ALERTS_FAILURE, payload: error });
      });
  };
};

export { getAlertsAction };
